import { ItemList } from 'orm'

class ChecklistQuestionList extends ItemList {
    getEntityKey() {
        return "admin/checklist_question"
    }
}

export const adminChecklistQuestionList = new ChecklistQuestionList("admin_checklist_question__default")
